<template>
  <div class="multi-matches">
    <div class="columns" v-for="(games, idx) in groups" :key="idx">
      <div
        class="column is-half-tablet is-one-third-desktop"
        v-for="{
          match_id: matchId,
          result,
          player_1_score: whiteScore,
          player_2_score: blackScore,
        } in games"
        :key="matchId"
      >
        <div
          class="single-game is-flex is-flex-direction-column is-align-items-center"
          :class="{
            'single-game__active':
              gameDataCopy[matchId].match &&
              !gameDataCopy[matchId].match.result &&
              gameDataCopy[matchId].playerColor &&
              gameDataCopy[matchId].turnColor ===
                gameDataCopy[matchId].playerColor,
          }"
        >
          <GameBoardCompact>
            <GameDataManagerFirebase :matchId="matchId" />
          </GameBoardCompact>

          <div
            class="single-game__actions is-flex is-justify-content-center is-align-items-center mt-2 px-4"
          >
            <b-button
              class="ml-2"
              icon-right="expand-arrows-alt"
              type="is-primary"
              @click="openGame(matchId)"
            />

            <strong class="ml-4" v-if="result">
              {{ result | matchResultText(whiteScore, blackScore) }}
            </strong>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      v-model="isModalDisplay"
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-label="Focus game"
      close-button-aria-label="Hide"
      aria-modal
      :width="1170"
      @close="closeGame"
      @after-enter="handleModalShow"
    >
      <template #default>
        <div class="focus-game" v-if="selectedMatchId">
          <!-- GAMEBOARD -->
          <GameBoard>
            <GameDataManagerFirebase :matchId="selectedMatchId" />
          </GameBoard>

          <GameDevInfo :gameData="gameDataCopy[selectedMatchId]"></GameDevInfo>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import GameBoard from "@/components/games/GameBoard.vue";
import GameBoardCompact from "@/components/games/compact/GameBoard.vue";
import GameDataManagerFirebase from "@/components/games/GameDataManagerFirebase.vue";
import GameDevInfo from "@/components/games/GameDevInfo.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    GameBoard,
    GameDataManagerFirebase,
    GameDevInfo,
    GameBoardCompact,
  },

  name: "MultiMatches",

  props: {
    matches: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  data() {
    return {
      showGameBoard: false,
      isModalDisplay: false,
      selectedMatchId: null,
    };
  },

  watch: {},

  computed: {
    ...mapGetters({
      getGameDataCopyByMatchId: "getGameDataCopyByMatchId",
    }),

    gameDataCopy() {
      const gameDataCopy = {};
      this.matches.forEach((m) => {
        gameDataCopy[m.id] = this.getGameDataCopyByMatchId(m.id);
      });
      return gameDataCopy;
    },

    groups() {
      return _.chunk(this.matches, 3);
    },
  },

  methods: {
    openGame(matchId) {
      this.selectedMatchId = matchId;
      this.isModalDisplay = true;
    },

    closeGame() {
      this.selectedMatchId = null;
      this.isModalDisplay = false;
    },

    handleModalShow() {
      // because chessboard is relative to parent,
      // rerender the chessboard after modal open,
      // otherwise chessboard is rendered with invalid size
      document.body.dispatchEvent(new Event("chessground.resize"));
    },
  },
};
</script>

<style scoped>
.multi-matches {
  width: 100%;
}
.focus-game {
  background-color: #fff;
  width: 100%;
  height: 580px;
  padding: 10px;
  position: relative;
  overflow: hidden;
}
.single-game {
  padding: 8px 26px 8px 8px;
}
.single-game__actions {
  width: 100%;
}
.single-game__active {
  background-color: antiquewhite;
  border-radius: 6px;
}
.single-game /deep/ .gameboard__chessboard {
  width: 320px;
  height: 320px;
}
@media (min-width: 576px) {
  .single-game /deep/ .gameboard__chessboard {
    width: 480px;
    height: 480px;
  }
}
@media (min-width: 768px) {
  .single-game /deep/ .gameboard__chessboard {
    width: 320px;
    height: 320px;
  }
}
@media (min-width: 800px) {
  .single-game /deep/ .gameboard__chessboard {
    width: 360px;
    height: 360px;
  }
}
@media (min-width: 900px) {
  .single-game /deep/ .gameboard__chessboard {
    width: 400px;
    height: 400px;
  }
}
@media (min-width: 1024px) {
  .single-game /deep/ .gameboard__chessboard {
    width: 280px;
    height: 280px;
  }
}
@media (min-width: 1070px) {
  .single-game /deep/ .gameboard__chessboard {
    width: 300px;
    height: 300px;
  }
}
@media (min-width: 1140px) {
  .single-game /deep/ .gameboard__chessboard {
    width: 320px;
    height: 320px;
  }
}
</style>
